export default __webpack_public_path__ + "static/media/regulatory--crosswalk-stop-on-red--g1.39942771.png";